import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: 796,
    height: 86,
    borderRadius: 9,
    boxShadow: '0 2px 13px 0 rgba(0, 0, 0, 0.17)',
    backgroundColor: theme.palette.background.default,
    paddingLeft: 32,
    paddingRight: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      width: 740
    },
    [theme.breakpoints.between('sm', 'md')]: {
      width: 460
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  selectorContainer: {
    width: '60%'
  },
  numberOfDaysContainer: {},
  paperWithoutShadow: {
    boxShadow: 'none',
    borderBottom: '1px solid #dfdfdf'
  }
}))

export default useStyles
